<template>
    <VJoyTemplate class="landing-sitemap">
        <template #template-title>
            <h1>{{ $t('sitemap.freelancers.categories') }}</h1>
        </template>
        <template #template-subtitle>
            <p>{{ $t('acquisition.banner.subtitle') }}</p>
        </template>
        <template #template-main>
            <SearchBlock page="freelancers_categories" />
            <div class="landing-sitemap__header">
                <h2>{{ $t('sitemap.categories.intro.title') }}</h2>
                <p>{{ $t('sitemap.categories.intro') }}</p>
            </div>
            <SitemapSection v-for="family in sitemapEntries" :key="family.familyId" :family="family" />
        </template>
    </VJoyTemplate>
</template>

<script setup lang="ts">
    import {createError, useAsyncData} from '#app';
    import {SearchBlock} from '#components';
    import {
        useTranslation,
        useSeoMeta,
        useTwitterMetaTags,
        TwitterMetaTags,
        useOpenGraphMetaTags,
        OpenGraphMetaTag,
        useLocale,
        useLocalePrefix,
    } from '#imports';
    import {VJoyTemplate} from '@maltjoy/core-vue';
    import {Configuration, SitemapApi} from '@api';
    import SitemapSection from '~/components/sitemap/Section.vue';

    const {t} = useTranslation();

    /* seo */
    const {isMultiLocaleHost} = useLocale();
    const title = t('sitemap.freelancers.categories.meta.title');
    const description = t('search.meta.description', ['', '']);
    useSeoMeta({
        ...(isMultiLocaleHost.value && {robots: 'noindex'}),
        title,
        description,
    });
    useTwitterMetaTags(new TwitterMetaTags({card: 'summary', title, description, t}));
    useOpenGraphMetaTags(new OpenGraphMetaTag({title, description, t}));

    /* data */
    const configuration = new Configuration({basePath: ''});
    const sitemapApi = new SitemapApi(configuration);
    const {getLocalePrefix, getLocaleCodeFromPrefix} = useLocalePrefix();
    const localePrefix = getLocalePrefix();
    const {data: sitemapEntries, error} = await useAsyncData(
        () => sitemapApi.getFreelancerCategories({locale: localePrefix ? getLocaleCodeFromPrefix(localePrefix) : undefined}),
        {deep: true},
    );
    if (error.value) {
        throw createError(error.value);
    }
</script>

<style lang="scss">
    @use '~/assets/styles/sitemap.scss';
</style>
